<template>
  <VDialogV3
    id="offers-registry-dialog"
    position="right"
    closable
    hide-footer
    :title="title"
    :loading="false"
    :width="width"
  >
    <OffersRegistry
      class="fill"
      :params="params"
      :hidden-columns="hiddenColumns"
      :selectable="selectable"
      :tender="tender"
      @tenderBid:created="$core.dialogs.OffersRegistryDialog.resolve()"
    />
  </VDialogV3>
</template>


<!-- Прокси над реестром предложений -->

<script lang="ts">
import type Tender        from '@/domains/Tenders/Tender';
import OffersRegistry     from '@/domains/Offers/components/OffersRegistry/OffersRegistry.vue';
import type OffersService from '@/domains/Offers/OffersService';

export default defineComponent({
  name: 'OffersRegistryDialog',

  components: { OffersRegistry },

  props: {
    /**
     * Заголовок диалога. Если не передан — дефолтный "Предложения".
     */
    title: {
      type:    String,
      default: 'Предложения',
    },

    /** Параметры запроса предложений (фильтры на уровне API). */
    params: {
      type:    Object as PropType<Parameters<typeof OffersService.getListPaginated>[0]>,
      default: null,
    },

    /** Скрытые колонки реестра по id. */
    hiddenColumns: {
      type:    Array as PropType<string[]>,
      default: () => [],
    },

    /** Режим выбора: клик по строке отдаёт предложение наружу. */
    selectable: {
      type:    Boolean,
      default: false,
    },

    /** Тендер, из которого открыли реестр — под него создаётся предложение. */
    tender: {
      type:    Object as PropType<Tender | null>,
      default: null,
    },

    /** Ширина диалогового окна */
    width: {
      type: String,
      default: null,
    }
  },
});
</script>
